// extracted by mini-css-extract-plugin
module.exports = {"header":"InstitutionHeader_header__2R7Kn","breadcrumb":"InstitutionHeader_breadcrumb__2jZgY","back":"InstitutionHeader_back__3nXav"};